let showToastHandler = null;

export const registerToast = (handler) => {
  showToastHandler = handler;
};

export const customToast = {
  success: (title, description = "",link) => {
    showToastHandler?.({
      type: "success",
      title,
      description,
      link
    });
  },

  error: (title, description = "") => {
    showToastHandler?.({
      type: "error",
      title,
      description,
    });
  },

  wish: (title, description = "") => {
    showToastHandler?.({
      type: "wish",
      title,
      description,
      link:'/account/favorites'
    });
  },
  info: (title, description = "") => {
    showToastHandler?.({
      type: "info",
      title,
      description
    });
  },
};
